(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("fedopsLogger", [], factory);
	else if(typeof exports === 'object')
		exports["fedopsLogger"] = factory();
	else
		root["fedopsLogger"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 